angular.module('homebot.directives')

  .directive('phoneInput', [function(){
    return {
      bindToController: {
        model: '=',
      },
      controllerAs: 'phoneCtrl',
      restrict: 'E',
      scope: {},
      template: `<input type="tel"
          ng-model="phoneCtrl.model"
          text-mask="phoneCtrl.maskOptions"
          pattern="^\\d{3}-\\d{3}-\\d{4}$"
          title="10 digit phone number with dashes"
          placeholder="888-777-7777"
        />`,

      controller: function(){
        let ctrl = this;

        ctrl.maskOptions = {
          mask: [/[2-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
        };
      },

      link: function($scope, el, attrs, ctrl){
        if(attrs.required !== undefined)
          el.find('input').attr('required', 'required');
      }
    }
  }]);
